import { CheckTokenResponse } from 'shared/api/auth/requests'
import { User, UserWithToken } from 'shared/types/user'

export const isUserAnonymous = (
  data: User | UserWithToken | CheckTokenResponse | {} = {}
) => {
  return (
    ('data' in data && data?.data?.roles?.includes?.('anonymous')) ||
    ('id' in data && data?.user_roles?.includes?.('anonymous'))
  )
}
